import {
  THREE,
  AnimationsManager,
  game,
  fpsManager,
  playersManager,
  gsap,
  PlayerSex,
  modes,
  HairColorTypes
} from '@powerplay/core-minigames'
import {
  gameConfig,
  animationsConfig,
  velocityConfig,
  pathsConfig
} from '../../config'
import {
  DisciplinePhases,
  PlayerStates,
  EmotionTypesFinish,
  EndTypesFinish,
  CustomGameEvents,
  Tasks,
  BlueBoxTextType,
  TutorialEventType,
  TutorialObjectiveIds
} from '../../types'
import {
  AthleteAnimationManager,
  AthleteVelocityManager
} from '.'
import { WorldEnvLinesCreator } from '../env/WorldEnvLinesCreator'
import { SpeedManager } from '@/app/SpeedManager/SpeedManager'
import { endManager } from '@/app/EndManager'
import { disciplinePhasesManager } from '@/app/phases/DisciplinePhasesManager'
import {
  gamePhaseState,
  textMessageState,
  textMessageTranslatableState,
  uiState
} from '@/stores'
import { Javelin } from './Javelin'
import { player } from './player'
import { trainingTasks } from '@/app/modes/training'
import { startPhaseStateManager } from '@/app/phases/StartPhase/StartPhaseStateManager'
import { audioHelper } from '@/app/audioHelper/AudioHelper'
import { tutorialFlow } from '@/app/modes/tutorial/TutorialFlow'
import { tutorialObjectives } from '@/app/modes/tutorial/TutorialObjectives'

/**
 * Trieda pre atleta
 */
export class Athlete {

  /** speed lock */
  public speedLockActive = false

  /** 3D objekt lyziara - cela scena */
  public athleteObject = new THREE.Object3D()

  /** Zakladny animacny manager */
  public animationsManager!: AnimationsManager

  /** Manager pre animacne stavy */
  public athleteAnimationManager = new AthleteAnimationManager(this)

  /** Manager rychlosti */
  public velocityManager = new AthleteVelocityManager(this)

  /** manager rychlosti */
  public speedManager = new SpeedManager()

  /** Ci uz je v cieli alebo nie */
  public finished = false

  /** Stav hraca */
  private state = PlayerStates.prepare

  /** Ci je aktivne aktualizovanie pohybovych animacii */
  public activeUpdatingMovementAnimations = false

  /** Posledna pozicia atleta */
  public lastAthletePosition = new THREE.Vector3()

  /** dolezity manager na pohyb */
  public worldEnvLinesManager!: WorldEnvLinesCreator

  /** Ci ide o hratelneho atleta alebo nie */
  public playable = false

  /** Emocia v cieli */
  public emotionFinish = EmotionTypesFinish.looser

  /** Ukoncenie v cieli */
  public endPhaseTwoFinish = EndTypesFinish.walk

  /** Nahodne cislo pre fazu dva, ci pojde walk alebo breathing */
  private randomNumberPhaseTwo = 0

  /** Kolko frameov treba pockat, aby sa nastavil stav konca */
  private framesToWaitForEndState = 0

  /** Ci sa maju aktualizovat framey (mali by sa po starte) */
  private updateFramesAfterStart = false

  /** Pocet frameov po starte */
  private framesAfterStart = 0

  /** PB */
  public personalBest = 0

  /** Ci bol PB v aktualnom pokuse */
  public pbThisAttempt = false

  /** posledny hod */
  public throwFinalLength = 0

  /** ostep */
  public javelin = new Javelin(this)

  /** ci bol preslap */
  public wasFoul = false

  /** rychlost na zaciatku natahnutia */
  public speedOnStartDrawing = 0

  /**
   * Konstruktor
   * @param uuid - UUID spera
   */
  public constructor(public uuid = '') {}

  /**
   * Nastavenie stavu atleta
   * @param state - stav
   * @param maxRandomDelay - maximalna hodnota randomu delayu od 0
   */
  public setState(state: PlayerStates, maxRandomDelay = 0): void {

    console.warn(state)
    const random = THREE.MathUtils.randFloat(0, maxRandomDelay)

    if (random === 0) {

      this.state = state

    } else {

      gsap.to({}, {
        duration: random,
        callbackScope: this,
        onComplete: () => {

          this.state = state
          console.log('state random', state, this.uuid, random)

        }
      })

    }



  }

  /**
   * Zistenie ci je aktualne dany stav
   * @param state -stav
   * @returns True, ak ano
   */
  public isState(state: PlayerStates): boolean {

    return this.state === state

  }

  /**
   * Zistenie ci je aktualny jeden z danych stavov
   * @param states - mozne stavy
   * @returns True, ak ano
   */
  public isOneOfStates(states: PlayerStates[]): boolean {

    return states.includes(this.state)

  }

  /**
   * Getter pre aktualne percento na drahe
   * @returns - actualPercent
   */
  public getActualPercentOnPath(): number {

    return this.worldEnvLinesManager.getActualPercent()

  }

  /**
   * Vratenie objektu atleta
   * @returns Objekt atleta
   */
  protected getObject(): THREE.Object3D {

    // mechanika bude v zdedenej classe
    return new THREE.Object3D

  }

  /**
   * Vytvorenie lyziara
   * @param athleteName - Meno alteta
   * @param nameForAnimations - Meno pre ziskanie animacii
   */
  public create(athleteName: string, nameForAnimations: string): void {

    this.playable = playersManager.getPlayerById(this.uuid)?.playable || false
    this.athleteObject = this.getObject()
    game.scene.add(this.athleteObject)

    // animacie
    this.animationsManager = new AnimationsManager(
      this.athleteObject,
      animationsConfig,
      game.animations.get(nameForAnimations),
      gameConfig.defaultAnimationSpeed,
      fpsManager
    )
    this.animationsManager.setDefaultSpeed(gameConfig.defaultAnimationSpeed)
    this.animationsManager.resetSpeed()

    // toto len aby fungovali uvodne nastavovacky, aj tak sa to potom poposuva
    const position = gameConfig.startPosition

    // threeJS Section
    this.athleteObject.position.set(position.x, position.y, position.z)
    this.athleteObject.name = athleteName


    this.worldEnvLinesManager = new WorldEnvLinesCreator(
      () => {

        // nic zatial

      },
      (actualPos: number, lastPos: number, finishPos: number) => {

        this.finishReached(actualPos, lastPos, finishPos)

      },
      () => {

        // nic zatial
        this.foulReached()

      },
      this
    )

    // nastavime vlasy
    this.setHair()

    this.javelin.create()

    this.personalBest = playersManager.getPlayer().personalBest

  }

  /**
   * Nastavenie vlasov a klobuku
   */
  private setHair(): void {

    const athlete = playersManager.getPlayerById(this.uuid)
    if (!athlete) return

    const sexWord = athlete.sex === PlayerSex.male ? 'm' : 'f'
    const maxCountHairTypes = sexWord === 'f' ? 7 : 8
    let hairType = athlete.hair ?? Math.floor(Math.random() * maxCountHairTypes) + 1
    if (hairType > maxCountHairTypes) hairType = maxCountHairTypes

    // stipec ma iba typ vlasov 5 pri zene
    const hairClip = this.athleteObject.getObjectByName('stipec_low') as THREE.Mesh
    if (hairClip) {

      hairClip.visible = (hairType === 5 && sexWord === 'f')
      const material = hairClip.material as THREE.MeshBasicMaterial
      if (material) material.color = new THREE.Color(0x783830).convertSRGBToLinear()

    }

    for (let j = 1; j <= 7; j += 1) {

      const meshHair = this.athleteObject.getObjectByName(`${j + sexWord}_low`) as THREE.Mesh
      if (meshHair) {

        meshHair.visible = j === hairType
        // ked toto nastavime, nebudu miznut vlasy
        meshHair.frustumCulled = false

        if (j === hairType) {

          const material = game.materialsToUse.basic.get('athleteHairTrack') as THREE.MeshBasicMaterial
          const hairColor = athlete.hairColor ?? HairColorTypes.brown
          material.color = new THREE.Color(gameConfig.hairColors[HairColorTypes[hairColor]]).convertSRGBToLinear()
          meshHair.material = material

          // kvoli roznym pohlaviam musime davat rozne textury podla pohlavia
          const texture = game.texturesToUse.main.get(`${athlete.sex}/athlete_hair`)
          if (texture) material.map = texture

        }

      }

    }

  }

  /**
   * Odstartovanie hraca
   */
  public start(): void {

    console.log('odstartoval atlet', this.uuid)
    this.setState(PlayerStates.run)
    this.speedManager.setActive(true)
    // dame rovno prvy input
    this.velocityManager.handleInputs()
    if (this.playable) gamePhaseState().showBar = true
    this.updateFramesAfterStart = true
    this.framesAfterStart = 0

  }

  /**
   * Aktualizovanie pozicie lyziara
   * @param positionObj - Pozicia
   * @param actualPhase - aktualna faza
   */
  private updatePlayerPosition(positionObj: THREE.Object3D, actualPhase: DisciplinePhases): void {

    this.athleteObject.position.copy(positionObj.position)

    const instalerp = [DisciplinePhases.start, DisciplinePhases.preStart].includes(actualPhase)

    let t = 0.5
    if (instalerp) t = 1

    this.athleteObject.quaternion.slerp(positionObj.quaternion, t)

    if (gameConfig.debugFoul) {

      let sphere = game.scene.getObjectByName('debug')
      if (sphere === undefined) {

        const geometrySphere = new THREE.SphereGeometry(0.1, 0.1, 0.1)
        const materialSphere = new THREE.MeshBasicMaterial({ color: 0x00FF00 })

        const meshSphere = new THREE.Mesh(geometrySphere, materialSphere)
        meshSphere.name = 'debug'
        game.scene.add(meshSphere)
        sphere = meshSphere

        // pivot hraca
        const materialSphere2 = new THREE.MeshBasicMaterial({ color: 0xFFFF00 })
        const meshSphere2 = new THREE.Mesh(geometrySphere, materialSphere2)
        meshSphere2.name = 'debugPivotPlayer'
        player.athleteObject.add(meshSphere2)

        // foul
        const materialSphere3 = new THREE.MeshBasicMaterial({ color: 0xFF0000 })
        const meshSphere3 = new THREE.Mesh(geometrySphere, materialSphere3)
        meshSphere3.name = 'debugFoulPosition'
        game.scene.add(meshSphere3)
        const positionFoul = this.worldEnvLinesManager.playerPath?.getPointAt(pathsConfig.positionFoul)
        if (positionFoul) meshSphere3.position.copy(positionFoul)


      }

      const offsetInPercent = pathsConfig.pivotPointOffset * this.worldEnvLinesManager.oneMeterInPercent
      const actualPercent = this.worldEnvLinesManager.getActualPercent()
      const position = this.worldEnvLinesManager.playerPath?.getPointAt(actualPercent + offsetInPercent)
      if (position) sphere.position.set(position.x, position.y, position.z)

    }

  }

  /**
   * Vratenie rotacie lyziara
   * @returns Quaternion lyziara
   */
  public getQuaternion(): THREE.Quaternion {

    return this.athleteObject.quaternion

  }

  /**
   * Vratenie pozicie atleta
   * @returns Pozicia atleta
   */
  public getPosition(): THREE.Vector3 {

    return this.athleteObject.position

  }

  /**
   * Aktualizovanie hraca po vykonani fyziky
   */
  public updateAfterPhysics(): void {

    if (disciplinePhasesManager.getActualPhase() === DisciplinePhases.end) return

    this.javelin.update()
    if (!this.speedLockActive || this.javelin.isFlying || this.wasFoul) {

      // velocity manager sa riesi iba ked je aktivna rychlost, inak je to neziaduce
      if (this.speedManager.isActive()) this.velocityManager.update()

      this.speedManager.update(
        this.velocityManager.getSpeedPower(),
        this.velocityManager.getMinIdealValue(),
        playersManager.getPlayerById(this.uuid)?.attribute.total || 0
      )

    }

    // kontrola a spustenie stavu konca
    this.manageEnd()

    this.athleteAnimationManager.update()

    if (gameConfig.debugShowConsoleMetersInFrame && this.updateFramesAfterStart) {

      this.framesAfterStart += 1

      if (this.framesAfterStart % 10 === 0) {

        const frame = this.framesAfterStart
        const percent = this.worldEnvLinesManager.getActualPercent()
        const percentStart = pathsConfig.positionsStart
        const meters = (percent - percentStart) * this.worldEnvLinesManager.totalPathLength
        console.log(`atlet ${this.uuid} presiel vo frame ${frame} tolkoto metrov: ${meters}`)

      }

    }


  }

  /**
   * Kontrola, ci nema nastat speed lock
   */
  protected checkSpeedLock(): void {

    if (
      !this.worldEnvLinesManager.isFinishEnabled() ||
      this.speedLockActive ||
      disciplinePhasesManager.actualPhase === DisciplinePhases.finish
    ) return
    this.activateSpeedLock()

  }

  /**
   * Aktualizovanie hraca pred vykonanim fyziky
   * @param actualPhase - Aktualna faza
   * @param inTop3 - Ci je hrac v top 3
   */
  public updateBeforePhysics(actualPhase: DisciplinePhases, inTop3 = false): void {

    if (disciplinePhasesManager.getActualPhase() === DisciplinePhases.end) return

    this.checkSpeedLock()

    const point = this.worldEnvLinesManager.update(
      this.speedManager,
      this.javelin.wasThrown,
      inTop3
    )
    this.updatePlayerPosition(point, actualPhase)

  }

  /**
   * Spomalenie po odhode, resp po neodhodeni
   * @param withoutDraw - True, ak ide o neodhodenie
   */
  public slowDownAfterThrow(withoutDraw = false): void {

    this.speedManager.setSpeedSlowDown(withoutDraw)

  }

  /**
   * Zobrazenie hlasky o uspesnosti rozbehu
   */
  private showMessageRunUp(): void {

    const quality = this.speedOnStartDrawing / velocityConfig.globalMaxSpeed
    let text = 'weakRunUp'
    let type = 4
    if (quality >= 0.85) {

      text = 'goodRunUp'
      type = 3
      tutorialObjectives.passObjective(TutorialObjectiveIds.runUp)

    }
    if (quality >= 0.95) {

      text = 'excellentRunUp'
      type = 2

    }
    if (quality >= 1) {

      text = 'perfectRunUp'
      type = 1

    }

    textMessageTranslatableState().$patch({
      show: true,
      text,
      type,
      top: 20
    })

  }

  /**
   * Aktivacia speed lock-u
   */
  public activateSpeedLock(): void {

    console.warn('SPEED LOCK', this.uuid)
    this.speedLockActive = true
    this.speedOnStartDrawing = player.speedManager.getActualSpeed()
    const runUpQ = Math.round((this.speedOnStartDrawing - 4.8) / (velocityConfig.globalMaxSpeed - 4.8) * 100)
    trainingTasks.saveTaskValue(Tasks.runUp, runUpQ)

    this.showMessageRunUp()

  }

  /**
   * Deaktivovanie spomalenia
   */
  public deactivateSpeedLock(): void {

    console.warn('SPEED LOCK end', this.uuid)
    this.speedLockActive = false

  }

  /**
   * Sprava konca behu v cieli
   */
  private manageEnd(): void {

    if (this.framesToWaitForEndState > 0) {

      this.framesToWaitForEndState -= 1
      if (this.framesToWaitForEndState === 0) {

        this.setEndState()

      }

    }

  }

  /**
   * Aktualizovanie animacii hraca
   * @param delta - Delta
   */
  public updateAnimations(delta: number): void {

    this.animationsManager.update(delta)

  }

  /**
   * Vypocet attrStrength
   * @returns attrStrength - number
   */
  public getAthleteAttributeStrength(): number {

    const totalStrength = playersManager.getPlayerById(this.uuid)?.attribute.total || 0

    let attrStrength = totalStrength / 4000 + 0.75
    if (totalStrength >= 1000) {

      attrStrength = (totalStrength - 1000) / 5000 + 1

    }

    return attrStrength

  }

  /**
   * Zistenie, ci sa ma prehravat breathing koniec (true) alebo walk (false)
   * @returns True, ak ma byt breathing koniec
   */
  private isBreathingEndOnFinish(): boolean {

    return this.randomNumberPhaseTwo === 1

  }

  /**
   * Start fazy 2 v cieli
   */
  private startFinishPhaseTwo(): void {

    // nerobime nic, ak ma byt walk koniec
    if (!this.isBreathingEndOnFinish()) return

    // spomalime a dame vydychanie
    this.endPhaseTwoFinish = EndTypesFinish.breathing

    this.speedManager.setDataForSpeedOnEnd(
      velocityConfig.speedOnEnd.minSpeed,
      velocityConfig.speedOnEnd.minSpeed / 2,
      velocityConfig.speedOnEnd.framesToStop,
      () => {

        this.speedManager.setDataForSpeedOnEnd(
          velocityConfig.speedOnEnd.minSpeed / 2,
          0,
          1,
          () => {

            // uz nemusime nic robit

          }
        )

      }
    )

  }

  /**
   * Spravanie pri dosiahnuti ciela
   * @param actualPosition - Aktualna pozicia v metroch
   * @param lastPosition - Posledna pozicia v metroch
   * @param finishPosition - Pozicia ciela v metroch
   */
  public finishReached(actualPosition: number, lastPosition: number, finishPosition: number): void {

    this.finished = true
    this.updateFramesAfterStart = false

    // mimo dennej ligy davame vsetkym superom, co este nepresli cielom po hracovi DNF, aby sa dobre vyhodnocovalo
    if (!modes.isDailyLeague() && this.playable) window.dispatchEvent(new CustomEvent(CustomGameEvents.playerFinished))

  }

  /**
   * Nastavenie stavu konca
   */
  private setEndState(): void {

    const resultEmotionWinner = endManager.isWinnerInFinish(this.uuid)
    if (resultEmotionWinner) {

      // davame animaciu happy
      this.emotionFinish = EmotionTypesFinish.winner

    }

    const { minSpeed, minSpeedWalk, framesToMinSpeed, randomizeEnd } = velocityConfig.speedOnEnd
    // musime si uz tu urcit random pre pokracovanie, aby sme vedeli, na aku rychlost spomalit
    this.randomNumberPhaseTwo = this.playable ? 1 : Math.round(Math.random())

    // zacneme spomalovat
    this.speedManager.setDataForSpeedOnEnd(
      this.speedManager.getActualSpeed(),
      this.isBreathingEndOnFinish() ? minSpeed : minSpeedWalk,
      THREE.MathUtils.randInt(framesToMinSpeed - randomizeEnd.minus, framesToMinSpeed + randomizeEnd.plus),
      () => {

        this.startFinishPhaseTwo()

      }
    )

  }

  /**
   * Nastavenie stavu preslapu
   */
  private foulReached(): void {

    if (this.wasFoul) return

    this.wasFoul = true
    tutorialFlow.eventActionTrigger(TutorialEventType.drawFoul)
    console.warn('PRESLAP')
    gamePhaseState().showBar = false
    gamePhaseState().showAngle = false
    uiState().blueBoxTextType = BlueBoxTextType.hidden

    audioHelper.setTimerToChangeAudienceAfterFoul()


    const showFirstLine = true
    const showSecondLine = false
    startPhaseStateManager.resetTextMessageFinishedEmits(showFirstLine, showSecondLine)
    textMessageState().$patch({
      showFirstLine: showFirstLine,
      showSecondLine: showSecondLine,
      firstLineText: 'foul',
      firstLineTextType: 0,
      secondLineTextType: 2,
      secondLineLeftNumber: 0,
      showMessage: true,
      showType: 3
    })
    if (disciplinePhasesManager.phaseDraw.isDrawing || disciplinePhasesManager.phaseDraw.isThrowing) return

    this.slowDownAfterThrow(true)
    this.setState(PlayerStates.runStop)
    this.javelin.endPathCallback()
    const windUpQ = Math.round((0 - 0.8) / 0.2 * 100)
    trainingTasks.saveTaskValue(Tasks.draw, windUpQ)
    const angleQ = Math.round(100 - Math.pow(Math.abs(0 - 35), 2))
    trainingTasks.saveTaskValue(Tasks.angle, angleQ)
    const timingQ = 0
    trainingTasks.saveTaskValue(Tasks.timing, timingQ)

  }

  /**
   * Zistime, ci nemame prepisat aktualny PB
   * @param result - Novy result
   */
  public checkNewPersonalBest(result: number): void {

    if (result > this.personalBest) {

      this.personalBest = result
      this.pbThisAttempt = true

    }

  }

  /**
   * reset atleta
   */
  public reset(): void {

    this.finished = false
    this.state = PlayerStates.prepare
    this.activeUpdatingMovementAnimations = false
    this.lastAthletePosition.set(0, 0, 0)
    this.emotionFinish = EmotionTypesFinish.looser
    this.endPhaseTwoFinish = EndTypesFinish.walk
    this.randomNumberPhaseTwo = 0
    this.framesToWaitForEndState = 0
    this.updateFramesAfterStart = false
    this.framesAfterStart = 0
    this.throwFinalLength = 0
    this.wasFoul = false
    this.speedLockActive = false

    this.velocityManager.reset()
    this.speedManager.reset()
    this.animationsManager.resetAll()
    this.worldEnvLinesManager.reset()
    this.athleteAnimationManager.reset()
    this.javelin.reset()
    trainingTasks.timingQualitySaved = false
    this.speedOnStartDrawing = 0
    this.pbThisAttempt = false

  }

}
